export default __webpack_public_path__ + "static/newsItem-image-2-18ef0742307334cddc4d79fb19cccc54.jpg";